import actions from '../../constants/actionTypes';
import request from '../../utils/request';

import { initializeApp } from '../../layout/actions';
import { isSuccess } from '../../utils/utils';
import { setGeneralError } from '../../layout/components/UniversalModal/actions';
import { EnumBellSound } from '../../constants/enum';

export function changeLanguage(language) {
  return (dispatch) => {
    dispatch({
      type: actions.CHANGE_LANGUAGE,
      response: language,
    });
    dispatch(initializeApp());
  };
}

export function setCurrentRestaurant(restaurant) {
  return (dispatch) => {
    if (restaurant.restaurant_id > 0) {
      return request
        .postMerchant('/api/restaurant/get_basic_info', {
          restaurant_ids: [restaurant.restaurant_id],
        })
        .then((response) => {
          if (isSuccess(response)) {
            const [restaurantExtraInfo] = response.reply.restaurants;
            dispatch({
              type: actions.SET_CURRENT_RESTAURANT,
              response: {
                ...restaurant,
                ...restaurantExtraInfo,
              },
            });
          } else {
            dispatch(setGeneralError(response.result));
          }
        });
    }
    return dispatch({
      type: actions.SET_CURRENT_RESTAURANT,
      response: restaurant,
    });
  };
}

export function openSelectCurrentRestaurantModal(
  isShow = true,
  refreshList = () => {},
  isShowAllRestaurantOption = true,
) {
  return {
    type: actions.GET_CURRENT_RESTAURANT,
    response: { isShow, refreshList, isShowAllRestaurantOption },
  };
}

export function toggleSidebarMenu(isShow = false) {
  return {
    type: actions.SET_SIDEBAR_COLLAPSE,
    response: isShow,
  };
}

export function setRingBell(response, ringBellSound = EnumBellSound.NORMAL.id) {
  return {
    type: actions.SET_RING_BELL,
    response: {
      isRingBell: response,
      ringBellSound,
    },
  };
}

export function setNotificationBell(notification) {
  return {
    type: actions.SET_NOTIFICATION_BELL,
    response: {
      notification,
    },
  };
}

export function removeNotificationBell({ notificationId, orderCode }) {
  return {
    type: actions.REMOVE_NOTIFICATION_BELL,
    response: {
      notificationId,
      orderCode,
    },
  };
}

export function setViewedNotification() {
  return {
    type: actions.SET_VIEWED_NOTIFICATION,
  };
}

export function setRingAllRestaurant(response) {
  return {
    type: actions.SET_RING_ALL_RESTAURANT,
    response: {
      isRingAllRestaurant: response,
    },
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Setting/actions.js